// extracted by mini-css-extract-plugin
module.exports = {"ol":"OrderedList_ol___N2Uy"};